import { render, staticRenderFns } from "./ReadyForReleaseRecords.vue?vue&type=template&id=f64dbc7c&"
import script from "./ReadyForReleaseRecords.vue?vue&type=script&lang=js&"
export * from "./ReadyForReleaseRecords.vue?vue&type=script&lang=js&"
import style0 from "./ReadyForReleaseRecords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports